<template>
  <div class="nodeBox" :class="{ 'selectedBox': this.selected }">
    <Handle
      type="target"
      position="left"
      :style="{
        height: '10px',
        width: '10px',
        backgroundColor: 'white',
        border: 'thin solid #dadada',
      }"
    />
    <NodeHeader :title="this.data.label" :hook="''" :icon="ListVideo" />
    <!-- <div class="flexLeftRow" style="align-items: center">
      <div class="imgBox">
        <ListVideo />
      </div>
      <h3>{{ this.data.label }}</h3>
    </div> -->
    <div
      style="
        width: 100%;
        height: 1px;
        margin: 10px 0;
        background-color: #dadada;
      "
    ></div>
    <!-- <p>{{ this.data.text }}</p> -->
    <div v-if="!this.toggledOptions">
      <BaseButton text="Open options" @click="toggleOptions()" />
    </div>
    <div v-if="this.toggledOptions">
      <!-- <img :src="this.img_src" /> -->
      <BaseButton text="Close options" @click="toggleOptions()" />
      <p>option 1</p>
      <p>option 2</p>
      <p>option 3</p>
    </div>
    <Handle
      type="source"
      position="right"
      :style="{
        height: '10px',
        width: '10px',
        backgroundColor: 'white',
        border: 'thin solid #dadada',
      }"
    />
  </div>
</template>

<script>
import { ListVideo } from "lucide-vue-next";
import { Handle } from "@vue-flow/core";
import BaseButton from "@/components/buttons/BaseButton.vue";
import NodeHeader from "./NodeComponents/NodeHeader.vue";

export default {
  name: "ExtractNode",
  props: {
    selected: Boolean,
    data: Object,
    // title: String,
    // text: String,
  },
  components: {
    Handle,
    // ListVideo,
    BaseButton,
    NodeHeader,
  },
  methods: {
    toggleOptions() {
      this.toggledOptions = !this.toggledOptions;
    },
  },
  data() {
    console.log(this.data);
    console.log(this.selected);
    return {
      toggledOptions: false,
      ListVideo,
    };
  },
};
</script>

<style scoped>
.nodeBox {
  border: thin solid #dadada;
  border-radius: 7px;
  padding: 10px;
  background: white;
}
.nodeBox:hover {
  border: thin solid #721cff;
}
.nodeBox:active {
  box-shadow: 0 0 0 3px #ccadff;
}
.selectedBox {
  border: thin solid #721cff;
  box-shadow: 0 0 0 3px #ccadff;
}
.imgBox {
  height: 35px;
  width: 35px;
  background: #721cff10;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
</style>
